import { useEffect } from 'react';
import { useAnalyticsContext } from 'src/common/metrics';
import { redirectToLegacyPainter } from 'src/utils/redirectUtils';
// TODO: This is temporary behavior due to the fact that the new domain isn't supported
// on 100% of devices due to SMA client adoption. We should add a redirect to Amazon
// page here eventually when we decide to deprecate Painter 1.0.
export const MissingAuthPage = () => {
    const rumClient = useAnalyticsContext();
    useEffect(() => {
        rumClient.recordEvent('MISSING_AUTH_PAGE_LOADED', {});
        // Redirect to web.shop-external.amazon with current path and dexp parameter
        redirectToLegacyPainter('missing_auth');
    }, [rumClient]);
    // Show nothing during redirect (instant redirect)
    return null;
};
